import { render } from "./courseIntroduce.vue?vue&type=template&id=6f5c4610&scoped=true"
import script from "./courseIntroduce.vue?vue&type=script&lang=js"
export * from "./courseIntroduce.vue?vue&type=script&lang=js"

import "./courseIntroduce.vue?vue&type=style&index=0&id=6f5c4610&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5c4610"]])

export default __exports__